import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {authGuard} from './utils/guards/auth.guard';
import {ROLE} from './utils/enums/role';
import {logoutGuard} from './utils/guards/logout.guard';
import {RegistrationComponent} from './views/body/registration/registration.component';
import {MyDetailsComponent} from './views/body/my-details/my-details.component';
import {UsersManagementComponent} from './views/body/users-management/users-management.component';
import {AdminComponent} from './views/body/admin/admin.component';
import {IntroductionAndMapComponent} from './views/body/introduction-and-map/introduction-and-map.component';
import {FnpComponent} from './views/body/fnp/fnp.component';
import {noAuthGuard} from './utils/guards/noauth.guard';
import {defaultRouteGuard} from './utils/guards/default-route.guard';
import {PrivacyPolicyComponent} from './views/body/privacy-policy/privacy-policy.component';
import {HelpDeskComponent} from './views/body/help-desk/help-desk.component';

const routes: Routes = [
    {
        path: '',
        canActivate: [defaultRouteGuard],
        runGuardsAndResolvers: 'always',
        children: [
            {path: 'logout', children: [], canActivate: [logoutGuard]},
            {
                path: 'intro',
                component: IntroductionAndMapComponent,
                canActivate: [authGuard],
                data: {role: ROLE.USER}
            },
            {
                path: 'fnp',
                component: FnpComponent,
                canActivate: [authGuard],
                data: {role: ROLE.USER}
            },
            {
                path: 'my-details',
                component: MyDetailsComponent,
                canActivate: [authGuard],
                data: {role: ROLE.USER}
            },
            {
                path: 'users-management',
                component: UsersManagementComponent,
                canActivate: [authGuard],
                data: {role: ROLE.ADMIN}
            },
            {
                path: 'registration',
                component: RegistrationComponent,
                canActivate: [noAuthGuard]
            },
            {
                path: 'privacy-policy',
                component: PrivacyPolicyComponent,
                canActivate: [noAuthGuard]
            },
            {
                path: 'help-desk',
                component: HelpDeskComponent,
                canActivate: [noAuthGuard]
            },
            {
                path: 'admin',
                component: AdminComponent,
                canActivate: [authGuard],
                data: {role: ROLE.ADMIN}
            }
        ]
    },
    {
        path: '**',
        redirectTo: ''
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
